import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ResponseModel } from '@dental-ui/account/models';
import { buildApiUrl, buildRequestHeaders } from '@dental-ui/shared/consts';
import { AuthStateService } from '@dental-ui/auth';

export interface StaticFileItem {
  id: string;
  type?: number;
  code?: string;
  description?: string;
  fileUrl?: string[];
  isActive: boolean;
  isStatic: boolean;
  modifiedOn?: string;
}

@Injectable({
  providedIn: 'root',
})
export class PortalStaticFilesApiService {
  private readonly http = inject(HttpClient);
  private readonly authState = inject(AuthStateService);

  loadStaticFiles(): Observable<StaticFileItem[]> {
    return this.http
      .get<ResponseModel<StaticFileItem[]>>(
        buildApiUrl('attachment.getAllByStaticFile'),
        { headers: buildRequestHeaders(true) }
      )
      .pipe(map((res) => res.data ?? []));
  }

  uploadStaticFile(file: File, type: number): Observable<unknown> {
    const formData = new FormData();
    formData.append('modifiedOn', new Date().toISOString());
    formData.append('modifiedBy', '0');
    formData.append('type', type.toString());
    formData.append('date', new Date().toISOString());
    formData.append('file', file, file.name);
    formData.append('isDeleted', 'false');
    formData.append('isStatic', 'true');

    const token = this.authState.token();
    const headers = token
      ? new HttpHeaders({ Authorization: `Bearer ${token}` })
      : new HttpHeaders();

    return this.http.post(buildApiUrl('attachment.upload'), formData, { headers });
  }

  deleteStaticFile(id: string): Observable<unknown> {
    return this.http.delete(
      `${buildApiUrl('attachment.delete')}?attachmentId=${id}`,
      { headers: buildRequestHeaders(true) }
    );
  }
}
